import { render, staticRenderFns } from "./index.vue?vue&type=template&id=298cc560&scoped=true&"
import script from "./index.vue?vue&type=script&lang=jsx&"
export * from "./index.vue?vue&type=script&lang=jsx&"
function injectStyles (context) {
  
  var style0 = require("./index.vue?vue&type=style&index=0&id=298cc560&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "298cc560",
  null
  ,true
)

export default component.exports